export default __webpack_public_path__ + "static/media/mo-art-complex-12-2@2x.15cbda49.png";